<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-spacer></v-spacer> 
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on" :loading="loading">
                                &nbsp;&nbsp;{{ selectedTeamData.name }}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile  v-for="(item,index) in myTeamsVisibleInMenu" :key="index" @click="setSelectedTeam(item)">
                                <v-list-tile-title small>{{item.name}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="myTeams.length > maxVisibleMenuItems" @click="viewAllTeams" title="Click to view all teams">
                                <v-list-tile-title small class="text-xs-center">
                                    <b>View All <v-icon small>open_in_new</v-icon></b> 
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="2" style="margin:1px -3px 0px -3px;"></v-progress-linear>                
            </v-card>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support.
            </v-alert>  

            <v-layout row wrap>
                <v-flex xs12 sm9 class="roles-panel">
                    <!-- ROLES & MEMBERS -->
                    <v-card class="elavation-1" style="margin-top:5px;">
                        <v-toolbar flat height="40">
                            <b>Roles & Members</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>                        
                        <v-card-text>
                            <div v-if="!loading">
                                <div v-for="(item,index) in roles" :key="index">

                                    <!-- Members Chips with collapse/expand -->
                                    <div v-if="(members = getTeamMembers(item.teamRoleId)) && members.length" class="chips-container">

                                        <div :class="hasEditRightsToTeamRolesPage?'primary--text role-name':'primary--text'" @click="navigateToTeamRolesPage(item.teamRoleId)" :title="hasEditRightsToTeamRolesPage?`Click to view ${item.name} permissions`:''">{{ item.name }}</div>

                                        <v-chip
                                            v-for="(member, idx) in (isExpanded(item.teamRoleId) 
                                                ? members 
                                                : members.slice(0, maxVisible))"
                                            :key="idx"
                                            @click="viewUserProfile(member.employee.userId)"
                                        >
                                            <v-avatar>
                                                <v-img :src="awsS3Helper.getAvatarUrl(member.employee.userId)"></v-img>
                                            </v-avatar>
                                            <span class="chips-item">
                                                {{ member.employee.firstName }} {{ member.employee.lastName }}
                                            </span>
                                        </v-chip>

                                        <!-- View more -->
                                        <div v-if="!isExpanded(item.teamRoleId) && members.length > maxVisible"
                                             class="view-more-link"
                                             @click="toggleRole(item.teamRoleId)">
                                            View {{ members.length - maxVisible }} more
                                        </div>

                                        <!-- Hide others -->
                                        <div v-if="isExpanded(item.teamRoleId) && members.length > maxVisible"
                                             class="view-more-link"
                                             @click="toggleRole(item.teamRoleId)">
                                            Hide others
                                        </div>
                                    </div>
                                </div>                               
                            </div>
                        </v-card-text>
                    </v-card>

                    <!-- TEAM EVENTS -->
                    <v-card class="elavation-1" style="margin-top:5px;">
                        <v-toolbar flat height="40">
                            <b>Upcoming Team Events</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-data-table
                            :headers="headers"
                            :items="events_list_filtered"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-chip small style="margin-left:-10px;">
                                            {{ getDateCaption(props.item.transDate) }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <span v-if="props.item.eventType=='birthday'">Birthdays</span>
                                        <span v-if="props.item.eventType=='timeoff'">Time Offs</span>
                                        <span v-if="props.item.eventType=='holiday'">{{ props.item.holiday }}</span>
                                    </td>
                                    <td>
                                        <div v-if="props.item.eventType=='birthday'">
                                            <v-chip small v-for="(item,index) in props.item.birthdayItems" :key="index" style="margin:-5px 0px 0px -5px;">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                                </v-avatar>
                                                {{item.firstName}} {{item.lastName}}
                                            </v-chip>
                                        </div>
                                        <div v-if="props.item.eventType=='timeoff'">
                                            <v-chip small v-for="(item,index) in props.item.ptoItems" :key="index" style="margin:-5px 0px 0px -5px;">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                                </v-avatar>
                                                {{item.firstName}} {{item.lastName}}
                                            </v-chip>
                                        </div>
                                        <span v-if="props.item.eventType=='holiday'">{{ props.item.holidayType }}</span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-flex>

                <!-- TEAM LINKS -->
                <v-flex xs12 sm3 class="links-panel">
                    <v-card class="elavation-1 sidebar-card">
                        <v-toolbar flat height="40">
                            <b>Team Links</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-navigation-drawer floating permanent stateless value="true">
                            <v-list dense>
                                <v-list-tile v-for="item in myTeamsPages" :key="item.title" @click="$router.push(item.pagePath)">
                                    <v-list-tile-action>
                                        <v-icon>{{ item.pageIcon }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ item.pageName }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-navigation-drawer>
                    </v-card>
                </v-flex>

            </v-layout>
        </v-flex>

        <!-- All Teams Dialog -->
        <v-dialog v-model="dialogAllMyTeams" width="700">   
            <view-all-my-teams ref="allTeamsRef" @send="setSelectedTeam" :dialogAllMyTeams.sync="dialogAllMyTeams"></view-all-my-teams>
        </v-dialog>
    </v-layout> 
</template>

<script>
import pageIds from '@/constants/app_ids'
import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'
import accessPermissions from '@/helpers/access-permissions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'MyTeamsMenu',
    components: {
        'view-all-my-teams': ()=> import('@/components/Team/ViewAllTeams'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Date',align: 'left',value: 'transDate', width: '20%', sortable:true},
                {text: 'Type',align: 'left',value: '', width: '30%', sortable:false},
                {text: 'Details',align: 'left',value: '', width: '50%', sortable:false},
            ],
            error: false,
            loading: false,
            menu_status: false,
            dialogAllMyTeams: false,
            maxVisibleMenuItems: 5,
            maxVisible: 5,            // maximum chips visible
            expandedRoles: {},        // track expanded roles
            myTeams: [],
            roles: [],
            events_list: []
        }
    },
    methods: {
        getDateCaption(date) {
            if (this.$moment(new Date()).format('MMM DD dd') == this.$moment(date).format('MMM DD dd'))
                return "Today"
            return this.$moment(date).format('MMM DD dd')
        },
        navigateToTeamRolesPage(teamRoleId) {
            if (this.hasEditRightsToTeamRolesPage) {
                this.$router.push(`/settings/teamroles/${teamRoleId}`)
            }
        },
        toggleRole(roleId) {
            this.$set(this.expandedRoles, roleId, !this.expandedRoles[roleId]);
        },
        isExpanded(roleId) {
            return !!this.expandedRoles[roleId];
        },
        viewAllTeams() {
            this.$refs.allTeamsRef.setData(this.myTeams)
            this.dialogAllMyTeams = true
        },
        setSelectedTeam(data){
            this.selectedTeamId = data.teamId
            const member = data.members.find(m => m.employee.userId === this.$store.state.userId)
            const role = member ? member.role : ''

            this.$store.commit("setSelectedTeamName", data.name)
            this.$store.commit("setSelectedTeamId", data.teamId)
            this.$store.commit("setSelectedTeamRole", role)
            this.$store.commit("setSelectedTeamPermissions", data.permissions)

            this.getEvents()
        },
        viewUserProfile(userId){
            this.$router.push(`/hr/employees/${userId}`)
        },
        getTeamMembers(roleId){
            return this.selectedTeamData
                .members
                .filter(x => x.visibleInMyTeams && x.roleId == roleId)
        },
        async getMyTeams() {
            try {
                this.loading = true
                const response = await teamApi.getMyTeams()
                if (response && response.status == 200) {
                    this.myTeams = response.data.myTeams
                    this.roles = response.data.roles

                    if (!this.savedSelectedTeamId) {
                        this.setSelectedTeam(this.myTeams[0])
                    } else {
                        const selectedTeamData = this.myTeams.find(x => x.teamId == this.savedSelectedTeamId)
                        this.setSelectedTeam(selectedTeamData)
                    }
                }
                this.loading = false
            } catch(error){
                this.error = true
                this.loading = false
            }
        },
        async getEvents(){
            try {
                const stored = localStorage.getItem(`TeamEvents_${this.savedSelectedTeamId}`)
                if (stored) {
                    this.events_list = JSON.parse(stored)
                }
                const response = await teamApi.getTeamEventsByMonthStartingToday()
                if (response && response.status == 200) {
                    this.events_list = response.data.items
                    localStorage.setItem(`TeamEvents_${this.savedSelectedTeamId}`, JSON.stringify(this.events_list))
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'My Teams',
            headerPageTitle: this.isMobile ? '' : 'Menu'
        })

        if (this.savedSelectedTeamId) {
            this.getMyTeams()
            this.getEvents()
        }else{
            await this.getMyTeams()
            this.getEvents()
        }
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
        hasEditRightsToTeamRolesPage(){
            const router = this.$router.resolve({ name: 'TeamRoles' })
            return accessPermissions.hasEditRights(router.route.fullPath)
        },
        events_list_filtered() {
            const today = this.$moment(new Date()).format('YYYY-MM-DD');

            // Step 1: filter by date range only
            const filtered = this.events_list.filter(x => x.transDate >= today);

            // Step 2: explode each item into separate event records
            const expanded = filtered.flatMap(item => {
                const events = [];

                if (item.withBirthDay) {
                    events.push({
                        ...item,
                        eventType: "birthday"
                    });
                }

                if (item.withPTO) {
                    events.push({
                        ...item,
                        eventType: "timeoff"
                    });
                }

                if (item.holiday) {
                    events.push({
                        ...item,
                        eventType: "holiday"
                    });
                }

                return events; // return 0–3 items
            });

            return expanded;
        },
        selectedTeamData() {
            const selectedData = this.myTeams.filter(x => x.teamId == this.savedSelectedTeamId)
            return selectedData.length ? selectedData[0] : this.myTeams[0]
        },
        savedSelectedTeamId() {
            return this.$store.state.selectedTeamId
        },
        myTeamsVisibleInMenu() {
            return this.myTeams.slice(0, this.maxVisibleMenuItems)
        },
        myTeamsPages() {
            if (this.selectedTeamData && this.selectedTeamData.permissions) {
                const app = this.$store.state.user_apps_list
                            .find(x => x.appId === pageIds.my_team)
                const teamPages = app && app.appPages ? app.appPages : []

                return teamPages.filter(page => {
                    const perm = this.selectedTeamData.permissions
                                    .find(p => p.appPageId === page.appPageId)
                    return perm && perm.view
                })
            }
        }
    }
}
</script>

<style scoped>
/* Flexbox ordering */
.roles-panel { order: 1; }
.links-panel { order: 2; }

@media (max-width: 600px) {
  .roles-panel { order: 2; }
  .links-panel { order: 1; }
}
.chips-container {
    margin: 0px 0px 20px 10px;
}
.chips-container > div {
    font-weight: bold;
}
.chips-item {
    cursor: pointer;
}

/* View more / hide link */
.view-more-link {
    color: #1976d2;
    cursor: pointer;
    margin-top: 6px;
    margin-left: 4px;
    font-size: 14px;
}
.view-more-link:hover {
    text-decoration: underline;
}
.sidebar-card {
    margin-top: 5px;
}
.role-name {
    text-decoration: underline;
}
.role-name:hover{
    cursor:pointer;
}
</style>
